import { Intake } from '../types';

export enum IntakeActionType {
    GET_ALL_INTAKES = 'GET_ALL_INTAKES',
    GET_ALL_ADMIN_INTAKES = 'GET_ALL_ADMIN_INTAKES',
    GET_INTAKE = 'GET_INTAKE',
    CREATE_INTAKES = 'CREATE_TARGET_GROUPS',
    UPDATE_INTAKES = 'UPDATE_TARGET_GROUPS',
    DELETE_INTAKES = 'DELETE_INTAKES',
    MERGE_INTAKES = 'MERGE_INTAKES',
}

interface GetAllIntakesAction {
    type: IntakeActionType.GET_ALL_INTAKES;
    payload: Array<Intake>;
}

interface GetAllAdminIntakesAction {
    type: IntakeActionType.GET_ALL_ADMIN_INTAKES;
    payload: Array<Intake>;
}

interface GetIntakeAction {
    type: IntakeActionType.GET_INTAKE;
    payload: Intake;
}
interface CreateIntakeAction {
    type: IntakeActionType.CREATE_INTAKES;
    payload: Intake;
}

interface UpdateIntakeAction {
    type: IntakeActionType.UPDATE_INTAKES;
    payload: Intake;
}

interface DeleteIntakesAction {
    type: IntakeActionType.DELETE_INTAKES;
    payload: Array<Intake>;
}

interface MergeIntakesAction {
    type: IntakeActionType.MERGE_INTAKES;
    payload: Array<Intake>;
}

export type IntakeAction =
    | GetAllIntakesAction
    | GetAllAdminIntakesAction
    | GetIntakeAction
    | CreateIntakeAction
    | UpdateIntakeAction
    | DeleteIntakesAction
    | MergeIntakesAction;
